var assign = require('../internals/object-assign');

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
require('../internals/export')({ target: 'Object', stat: true, forced: Object.assign !== assign }, { assign: assign });



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.object.assign.js
// module id = 278
// module chunks = 1